module.exports = __webpack_public_path__ + "img/shiba-body-level1.dab14fbd.png";